const createAnimationHasSeenThirdTabSelector = (
    state: sage.state.IRedux
): boolean => state.createAnimation.hasSeenThirdTab;

export default createAnimationHasSeenThirdTabSelector;
